'use strict';

import $ from 'jquery';
import Tooltip from 'bootstrap/js/src/tooltip';
// import mpro from './mpro.init';

class MpTooltip extends Tooltip {
	constructor(element, config) {
		// super(element, {...config, ...options});
		super(element, config);
		// Attach the instance to the element
		// @ts-ignore
		this._element._tooltip = this;
	}

	dispose() {
		// Detach the instance from the element
		// @ts-ignore
		this._element._tooltip = null;
		super.dispose();
	}
}

// We cannot add both tooltip and popover delegates on the same container
export const bodyTooltip = new MpTooltip(document.querySelector('[data-tooltip-container]'), {
	selector: '[data-bs-toggle="tooltip"]',
	container: document.body,
	trigger: 'hover',
	// popperConfig: {
	// 	modifiers: [
	// 		{
	// 			name: 'computeStyles',
	// 			options: {
	// 				gpuAcceleration: false, // true by default
	// 			},
	// 		},
	// 	]
	// }
});


// Close Tooltips
mpro.removeTooltips = function($container) {

	// Remove bs5 popovers
	for (const element of $('[data-bs-toggle="tooltip"]', $container)) {
		try {
			// @ts-ignore
			element._tooltip && element._tooltip.dispose();
		}
		catch (e) {
			console.warn('Error while trying to dispose tooltip instance for element (%o): %o', element, e);
		}
	}

	// Remove all orphan tooltips
	$('div[role="tooltip"]').remove();
};

export default mpro;
